import React from 'react';
export function UrgencySection() {
  return <section className="w-full bg-black" data-id="element-139">
      {/* Top gold line */}
      <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#C5A014]/40 to-transparent" data-id="element-140" />

      <div className="py-8 md:py-10 px-4 text-center max-w-3xl mx-auto space-y-3" data-id="element-141">
        <p className="font-['Crimson_Text'] text-sm md:text-base tracking-[0.2em] uppercase text-zinc-400" data-id="element-142">
          Actualizado a marzo 2026
        </p>
        <p className="font-['Crimson_Text'] text-lg md:text-xl text-zinc-200 leading-relaxed" data-id="element-143">
          Capturado el 13 de marzo de 2026. Este libro reconstruye toda la
          historia hasta el día de su traslado a Estados Unidos.
        </p>
      </div>

      {/* Bottom gold line */}
      <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#C5A014]/40 to-transparent" data-id="element-144" />
    </section>;
}